var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRdWins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.061,
    height: 29.029,
    viewBox: "0 0 21.061 29.029",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M43.734 16.891a2.073 2.073 0 0 0-1.173-1.4L34.07 11.74l1.187-3.293a.646.646 0 0 0-.208-.717.678.678 0 0 0-.771-.057l-4.129 2.414a11.246 11.246 0 0 0-4.585 5.13 15.866 15.866 0 0 0-1.435 6.26 19.429 19.429 0 0 0 1.385 7.695H38.07s.326-2.547-.251-3.555l-2.834-4.94.38.126a1.582 1.582 0 0 0 .5.079 1.621 1.621 0 0 0 1.22-.549 1.317 1.317 0 0 1 1.435-.38l2.009.692a2.063 2.063 0 0 0 .674.111 2.091 2.091 0 0 0 1.528-.678l.66-.717a2.041 2.041 0 0 0 .488-1.847z",
    transform: "translate(-20.637 -7.578) translate(20.637 7.578) translate(-22.873 -7.578)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.561 69.82a.631.631 0 0 0-.588.664v2.023h-.746a.628.628 0 0 0-.588.664v2.687a.628.628 0 0 0 .588.664h16.5a.628.628 0 0 0 .588-.664V73.17a.628.628 0 0 0-.588-.664h-.775v-2.022a.631.631 0 0 0-.588-.664z",
    transform: "translate(-20.637 -7.578) translate(20.637 7.578) translate(-20.637 -47.492)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRdWins);
export default __webpack_public_path__ + "static/media/rd-wins.ba7486769bf9eaaa8ed3836a9866e427.svg";
export { ForwardRef as ReactComponent };